import { render } from "./SaldoPage.vue?vue&type=template&id=62963eaa&scoped=true"
import script from "./SaldoPage.vue?vue&type=script&lang=js"
export * from "./SaldoPage.vue?vue&type=script&lang=js"

import "./SaldoPage.vue?vue&type=style&index=0&id=62963eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62963eaa"]])

export default __exports__